import { CodeBase } from "./_codeBase";

/** トリガ区分*/
export class TriggerDiv extends CodeBase<TriggerDiv>
{
    /** トリガ区分: "01", "値の変更", ""*/
    public static readonly VAUE_CHANGE: TriggerDiv = new TriggerDiv("01", "値の変更", "");
    /** トリガ区分: "02", "特定文言が入力された" ""*/
    public static readonly SPEC_WORDING_INPUT: TriggerDiv = new TriggerDiv("02", "特定文言が入力された", "");
    /** トリガ区分: "03", "項目の追加" ""*/
    public static readonly ADD_ITEM: TriggerDiv = new TriggerDiv("03", "項目の追加", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): TriggerDiv[] {
        return [
            TriggerDiv.VAUE_CHANGE,
            TriggerDiv.SPEC_WORDING_INPUT,
            TriggerDiv.ADD_ITEM,
        ];
    }
}
